import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfReportTask } from '@services/sessions/pdfreport.service';

@Component({
  selector: 'app-pdf-task-modal',
  templateUrl: './pdf-task-modal.component.html',
  styleUrls: ['./pdf-task-modal.component.scss'],
})
export class PdfTaskModalComponent {
  @Input() task: PdfReportTask<any>;

  constructor(private activeModal: NgbActiveModal) {}

  done() {
    this.activeModal.close();
  }
}
